'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useIsDesktop } from '@/shared/lib/react/useIsDesktop';
import { CustomButton, Typography } from '@/shared/ui/atoms';
import ConsultModal from '@/widgets/landing/modals/ui/templates/ConsultModal';
import * as S from './styles';

const CTASection = () => {
  const isLg = useIsDesktop();
  const subTitle = isLg ? '운영 부담은 줄이고, 다양한 채널에 최적화된 고품질 콘텐츠를 발행해보세요.' : '운영 부담은 줄이고, 다양한 채널에 최적화된\n고품질 콘텐츠를 발행해보세요.';
  const [open, setOpen] = useState(false);
  return (
    <section className={S.section}>
      <Typography as="h2" className={S.heading}>
        단순 블로그 대행을 넘어 <br />
        우리만의 브랜드 미디어를 구축합니다.
      </Typography>
      <Typography as="p" className={S.subtitle}>
        {subTitle}
      </Typography>
      <CustomButton
        className={S.ctaButton}
        onClick={() => {
          setOpen(true);
        }}
      >
        바로 상담 신청하기
        <Image src="/images/icons/arrow-icon.png" alt="arrow-right" width={24} height={24} className={S.ctaArrow} />
      </CustomButton>
      <ConsultModal open={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default CTASection;
